// src/components/Reports/LedgerTable.tsx
import React from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Button,
	TableFooter
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { formatDate } from "../../../utils/calculations";
import { RecentInvoiceAndReturnsEntry } from "../../../hooks/useRecentInvoiceAndReturns";

interface InvoiceAndReturnsTableProps {
	ledgerEntries: RecentInvoiceAndReturnsEntry[];
	maskProfit?: boolean;
}

export const InvoiceAndReturnsTable: React.FC<InvoiceAndReturnsTableProps> = ({
	ledgerEntries,
	maskProfit
}) => {
	const totalAmount = ledgerEntries
		.filter((entry) => entry.type === "Invoice" || entry.type === "Return")
		.reduce((sum, entry) => sum + entry.amount, 0);
	return (
		<>
			{ledgerEntries === null || ledgerEntries.length === 0 ? (
				<p>No Sales Settlement Report entries found.</p>
			) : (
				<Paper elevation={3} sx={{ p: { xs: 1, md: 2 }, mt: 0 }}>
					{/* <Typography variant="h5" gutterBottom>
						Sales Settlement Report
					</Typography> */}
					<TableContainer
						component={Paper}
						sx={{ overflowX: "auto" }}
					>
						<Table
							size="small"
							sx={{
								"& .MuiTableCell-root": {
									border: "1px solid rgba(224, 224, 224, 1)"
								},
								"& .MuiTableCell-head": {
									fontWeight: "bold"
								}
							}}
						>
							<TableHead>
								<TableRow>
									<TableCell>Invoice Number</TableCell>
									<TableCell>Date</TableCell>
									<TableCell>Type</TableCell>
									<TableCell>Customer</TableCell>

									<TableCell>Sale Amount</TableCell>
									<TableCell>CASH</TableCell>
									<TableCell>UPI</TableCell>
									<TableCell>Outstanding</TableCell>
									<TableCell>Profit</TableCell>
									<TableCell align="center">View</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{ledgerEntries.map((entry, index) => (
									<TableRow key={index}>
										<TableCell>
											{entry.invoiceNumber}
										</TableCell>
										<TableCell>
											{formatDate(entry.date)}
										</TableCell>
										<TableCell
											style={{
												color:
													entry.type === "Return"
														? "red"
														: entry.type ===
															  "Invoice"
															? "green"
															: "blue"
											}}
										>
											{entry.type}
										</TableCell>
										<TableCell>{entry.details}</TableCell>

										<TableCell
											style={{
												color:
													entry.type === "Return"
														? "red"
														: entry.type ===
															  "Invoice"
															? "green"
															: "blue"
											}}
										>
											₹{entry.amount.toFixed(2)}
										</TableCell>
										<TableCell>
											₹{entry.cash.toFixed(2)}
										</TableCell>
										<TableCell>
											₹{entry.upi.toFixed(2)}
										</TableCell>
										<TableCell>
											₹{entry.outstanding.toFixed(2)}
										</TableCell>
										<TableCell>
											{maskProfit
												? "••••••"
												: `₹${entry.profit.toFixed(2)}`}
										</TableCell>
										<TableCell align="center">
											<Button
												variant="contained"
												size="small"
												onClick={() =>
													window.open(
														`/invoice?invoiceNumber=${entry.invoiceNumber}`,
														"_blank"
													)
												}
												startIcon={<VisibilityIcon />}
											>
												View
											</Button>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
							<TableFooter>
								<TableRow>
									<TableCell
										colSpan={4}
										sx={{ fontWeight: "bold" }}
										align="right"
									>
										Total
									</TableCell>
									<TableCell
										sx={{
											fontWeight: "bold",
											color:
												totalAmount < 0
													? "red"
													: "green"
										}}
									>
										₹{totalAmount.toFixed(2)}
									</TableCell>
									<TableCell sx={{ fontWeight: "bold" }}>
										₹
										{ledgerEntries
											.reduce(
												(sum, entry) =>
													sum + entry.cash,
												0
											)
											.toFixed(2)}{" "}
										(CASH)
									</TableCell>
									<TableCell sx={{ fontWeight: "bold" }}>
										₹
										{ledgerEntries
											.reduce(
												(sum, entry) => sum + entry.upi,
												0
											)
											.toFixed(2)}{" "}
										(UPI)
									</TableCell>
									<TableCell sx={{ fontWeight: "bold" }}>
										₹
										{ledgerEntries
											.reduce(
												(sum, entry) =>
													sum + entry.outstanding,
												0
											)
											.toFixed(2)}{" "}
										(Outstanding)
									</TableCell>
									<TableCell sx={{ fontWeight: "bold" }}>
										{maskProfit
											? "••••••"
											: `₹${ledgerEntries
													.reduce(
														(sum, entry) =>
															sum + entry.profit,
														0
													)
													.toFixed(2)}`}{" "}
										(Profit)
									</TableCell>
									<TableCell colSpan={1} />
								</TableRow>
							</TableFooter>
						</Table>
					</TableContainer>
				</Paper>
			)}
		</>
	);
};
